module.exports = __webpack_public_path__ + "img/TopFlowerFront.0630f03b.png";